"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentMedium;
(function (PaymentMedium) {
    PaymentMedium["StripeOnline"] = "StripeOnline";
    PaymentMedium["StripeTerminal"] = "StripeTerminal";
    PaymentMedium["StripeVirtualTerminal"] = "StripeVirtualTerminal";
})(PaymentMedium || (PaymentMedium = {}));
//# sourceMappingURL=PaymentReceivedJobInput.js.map